<template>
  <vue-scroll>
    <el-row :gutter="10" type="flex" justify="space-between">
      <el-col :xs="24" :sm="12" :md="12" :lg="5" :xl="5">
        <card-total
          text="Total Clientes"
          icon="el-icon-user-solid info-text"
          :total="TotalClientes"
          :loading.sync="loading"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="5" :xl="5">
        <card-total
          text="Total GPS"
          icon="mdi mdi-satellite-uplink primary-text"
          :total="TotalGPS"
          :percent="PorcentajeTotal"
          :loading.sync="loading"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="5" :xl="5">
        <card-total
          text="Total GPS Activos"
          icon="mdi mdi-satellite-uplink success-text"
          :total="TotalGPSActivos"
          :percent="PorcentajeActivo"
          :loading.sync="loading"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="5" :xl="5">
        <card-total
          text="Total GPS Inactivos"
          icon="mdi mdi-satellite-uplink danger-text"
          :total="TotalGPSInactivos"
          :percent="PorcentajeInactivos"
          :loading.sync="loading"
        />
      </el-col>
    </el-row>
    <el-row :gutter="10" type="flex" class="row-bg rowx" justify="end">
      <rabbey-toolbox
        class="mt-0 toolbox"
        :filterables="true"
        @filter-search="onFilterSearch"
      >
      </rabbey-toolbox>
    </el-row>
    <el-row>
      <rabbey-table-3
        ref="table"
        class="table"
        :show-summary="true"
        sum-text="Totales de GPS"
        :loading.sync="loading"
        :columns="columnas"
        :data.sync="Resultado"
        :page-sizes="[10, 30, 50, 100, 500, 1000]"
      />

      <report-gps-detail
        ref="detail"
        :isVisible="isVisibleReportDetail"
        :rowdata="Traccarrowdata"
        :columnname="Traccarcolumnname"
        @onDrawerClose="onDetailDrawerClose"
      />
    </el-row>
  </vue-scroll>
</template>

<script>
import ReportGpsDetail from "@/components/technical_support/reports/TraccarGpsReportDetail.vue";
import ReportGPSHyperLink from "@/components/functionals/ReportGPSHyperLink.vue";
import CardTotal from "@/components/CardTotalOriginal.vue";

export default {
  name: "TraccarGpsReport",
  components: {
    ReportGpsDetail,
    CardTotal
  },
  data() {
    return {
      loading: false,
      Resultado: [],
      Traccarrowdata: {},
      Traccarcolumnname: "",
      isVisibleReportDetail: false,
      columnas: [
        {
          prop: "ClientCode",
          label: "Codigo del Cliente",
          fixed: true,
          sortable: true,
          width: "170"
        },
        {
          prop: "ClientName",
          label: "Nombre del Cliente",
          sortable: true,
          width: "300"
        },
        {
          prop: "ClientService",
          label: "Servicio al Cliente",
          sortable: true
        },
        {
          prop: "TotalGps",
          label: "Total de GPS",
          sortable: true,
          align: "center",
          cellAtrrs: {
            openDetail: this.openDetail
          },
          formatter: ReportGPSHyperLink
        },
        {
          prop: "OnlineGps",
          label: "GPS Activos",
          sortable: true,
          align: "center",
          cellAtrrs: {
            openDetail: this.openDetail
          },
          formatter: ReportGPSHyperLink
        },
        /*
        {
          prop: "idle",
          label: "GPS Estacionados",
          sortable: true,
          align: "center",
          cellAtrrs: {
            openDetail: this.openDetail
          },
          formatter: ReportGPSHyperLink
        },
        */
        {
          prop: "OfflineGps",
          label: "GPS Inactivos",
          sortable: true,
          align: "center",
          cellAtrrs: {
            openDetail: this.openDetail
          },

          formatter: ReportGPSHyperLink /*(row, col) => {
            //const { Quantity } = row;

          return <a onclick="openDetail(15223, 555)" class="bold, red">{row.offline} </a>;
          },*/
        }
        /*
        {
          prop: "signal_lost",
          label: "GPS sin señal satelital",
          sortable: true,
          align: "center",
          width: "200",
          cellAtrrs: {
            openDetail: this.openDetail
          },

          formatter: ReportGPSHyperLink /*(row, col) => {
            //const { Quantity } = row;

          return <a onclick="openDetail(15223, 555)" class="bold, red">{row.offline} </a>;
          },**
        }
        */
      ]
    };
  },

  created() {
    this.ObtainTraccarGpsReport();
  },

  computed: {
    TotalClientes() {
      return this.Resultado.length;
    },
    TotalGPS() {
      return this.Resultado.map((item) => item.TotalGps).reduce(
        (a, b) => a + b
      );
    },
    PorcentajeTotal() {
      return Math.round((this.TotalGPS / this.TotalGPS) * 100);
    },
    TotalGPSActivos() {
      return this.Resultado.map((item) => item.OnlineGps).reduce(
        (a, b) => a + b
      );
    },
    PorcentajeActivo() {
      return Math.round((this.TotalGPSActivos / this.TotalGPS) * 100);
    },
    TotalGPSInactivos() {
      return this.Resultado.map((item) => item.OfflineGps).reduce(
        (a, b) => a + b
      );
    },
    PorcentajeInactivos() {
      return Math.round((this.TotalGPSInactivos / this.TotalGPS) * 100);
    }
  },

  methods: {
    async ObtainTraccarGpsReport() {
      this.loading = true;
      this.$http
        .get("/api/TraccarGPS/GetTraccarGpsReport")
        .then((resp) => {
          console.log("Reporte Traccar GPS", resp);
          this.Resultado = resp.data;
        })
        .catch((err) => {
          console.error("Error al consultar reporte de GPS Traccar: ", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onFilterSearch(query) {
      this.$refs.table.filterData(query);
      return;
    },
    openDetail(row, col) {
      console.log("traccar row: ", row, "traccar column: ", col);
      this.Traccarrowdata = row;
      this.Traccarcolumnname = col;
      this.isVisibleReportDetail = true;
      //this.$refs.detail.show(row, col);
    },
    onDetailDrawerClose(val) {
      this.isVisibleReportDetail = val;
    }
  }
};
</script>

<style scoped></style>
